 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780062231437_COVER from '@/components/text/9780062231437_Cover'
 import TEXT9780062231437_ENDPAPER from '@/components/text/9780062231437_Endpaper'
 import LOVE_1 from '@/components/love_1'
 import TEXT9780062231437_TITLEPAGE from '@/components/text/9780062231437_Titlepage'
 import TEXT9780062231437_EPIGRAPH from '@/components/text/9780062231437_Epigraph'
 import TEXT9780062231437_FRONTMATTER from '@/components/text/9780062231437_Frontmatter'
 import TEXT9780062231437_CONTENTS from '@/components/text/9780062231437_Contents'
 import TEXT9780062231437_INTRODUCTION from '@/components/text/9780062231437_Introduction'
 import TEXT9780062231437_CHAPTER_1 from '@/components/text/9780062231437_Chapter_1'
 import TEXT9780062231437_CHAPTER_2 from '@/components/text/9780062231437_Chapter_2'
 import TEXT9780062231437_CHAPTER_3 from '@/components/text/9780062231437_Chapter_3'
 import TEXT9780062231437_CHAPTER_4 from '@/components/text/9780062231437_Chapter_4'
 import TEXT9780062231437_CHAPTER_5 from '@/components/text/9780062231437_Chapter_5'
 import TEXT9780062231437_CHAPTER_6 from '@/components/text/9780062231437_Chapter_6'
 import TEXT9780062231437_CHAPTER_7 from '@/components/text/9780062231437_Chapter_7'
 import TEXT9780062231437_CHAPTER_8 from '@/components/text/9780062231437_Chapter_8'
 import TEXT9780062231437_CHAPTER_9 from '@/components/text/9780062231437_Chapter_9'
 import TEXT9780062231437_CHAPTER_10 from '@/components/text/9780062231437_Chapter_10'
 import TEXT9780062231437_CHAPTER_11 from '@/components/text/9780062231437_Chapter_11'
 import TEXT9780062231437_CHAPTER_12 from '@/components/text/9780062231437_Chapter_12'
 import TEXT9780062231437_CHAPTER_13 from '@/components/text/9780062231437_Chapter_13'
 import TEXT9780062231437_CHAPTER_14 from '@/components/text/9780062231437_Chapter_14'
 import TEXT9780062231437_CHAPTER_15 from '@/components/text/9780062231437_Chapter_15'
 import TEXT9780062231437_CHAPTER_16 from '@/components/text/9780062231437_Chapter_16'
 import TEXT9780062231437_CHAPTER_17 from '@/components/text/9780062231437_Chapter_17'
 import TEXT9780062231437_CHAPTER_18 from '@/components/text/9780062231437_Chapter_18'
 import TEXT9780062231437_CHAPTER_19 from '@/components/text/9780062231437_Chapter_19'
 import TEXT9780062231437_FINAL_THOUGHTS from '@/components/text/9780062231437_Final_Thoughts'
 import LOVE_2 from '@/components/love_2'
 import TEXT9780062231437_ACKNOWLEDGEMENTS from '@/components/text/9780062231437_Acknowledgements'
 import TEXT9780062231437_NOTES from '@/components/text/9780062231437_Notes'
 import TEXT9780062231437_BIBLOGRAPHY from '@/components/text/9780062231437_Biblography'
 import TEXT9780062231437_PHOTO_SECTION from '@/components/text/9780062231437_Photo_Section'
 import TEXTABOUT_THE_AUTHORS from '@/components/text/About_the_Authors'
 import TEXT9780062231437_CREDITS from '@/components/text/9780062231437_Credits'
 import TEXT9780062231437_COPYRIGHT from '@/components/text/9780062231437_Copyright'
 import TEXTABOUT_THE_PUBLISHER from '@/components/text/About_the_Publisher'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780062231437_Contents",
 			"name" : "text/9780062231437_Contents",
 			"component" : TEXT9780062231437_CONTENTS
 		},
 		{
 			"path" : "/text/9780062231437_Introduction",
 			"name" : "text/9780062231437_Introduction",
 			"component" : TEXT9780062231437_INTRODUCTION
 		},
 		{
 			"path" : "/text/9780062231437_Chapter_1",
 			"name" : "text/9780062231437_Chapter_1",
 			"component" : TEXT9780062231437_CHAPTER_1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js